export function getUserProfilePath(userOrId) {
  const id = typeof userOrId === 'object' ? userOrId?.id : userOrId;
  if (!id) return null;
  return `/users/${id}`;
}

export function getPlayersListPath() {
  return '/joueurs';
}
